import {
    TableCell,
    TableRow
} from '@mui/material';
import React from 'react';
import { stringToLocaleDateString } from '../../helpers';

export const DateTableRow = ({ label, stringDate, ...props }) => {
    return (
        <>
            <TableRow>
                <TableCell style={{ width: "20%" }}>
                    {label}
                </TableCell>
                <TableCell>
                    {stringToLocaleDateString(stringDate)}
                </TableCell>
            </TableRow>
        </>
    );
}